import { appendReportSummary, styleRecordSheet } from '../../utils/excelExport';

export function groupSelectedRecords(rows = []) {
  const groups = new Map();
  rows.forEach(row => {
    const key = row.inventory_id || row.item_id || row.inventory_batch_product_id;
    if (!groups.has(key)) {
      groups.set(key, {
        id: key,
        warehouse_id: row.warehouse_id,
        warehouse_name: row.warehouse_name,
        warehouse_code: row.warehouse_code,
        warehouse_city: row.warehouse_city,
        customer_id: row.customer_id,
        customer_name: row.customer_name,
        customer_logo: row.customer_logo,
        packaging_type: row.packaging_type,
        packaging_quantity: row.packaging_quantity,
        total_carton_qty: row.total_carton_qty,
        marko: row.marko,
        status: row.inventory_status,
        reference_number: row.sku,
        products: [],
        cartons: new Map(),
        gross_weight: 0,
        net_weight: 0,
        cbm: 0,
      });
    }
    const group = groups.get(key);
    (row.products?.length ? row.products : [row]).forEach(product => {
      const batchId = product.inventory_batch_id ?? row.inventory_batch_id;
      const batchKey = batchId ?? `product:${product.inventory_batch_product_id || product.id}`;
      if (!group.cartons.has(batchKey)) group.cartons.set(batchKey, {
        quantity: product.batch_quantity ?? row.batch_quantity ?? row.total_carton_qty,
        gross_weight: product.batch_gross_weight ?? row.batch_gross_weight,
        net_weight: product.batch_net_weight ?? row.batch_net_weight,
        cbm: product.batch_cbm ?? row.batch_cbm,
        products: [],
      });
      group.cartons.get(batchKey).products.push({
        id: product.inventory_batch_product_id || product.id,
        product_id: product.product_id,
        name: product.product_name, quantity: product.quantity,
        gross_weight: product.product_gross_weight ?? product.gross_weight,
        net_weight: product.product_net_weight ?? product.net_weight,
        cbm: product.cbm,
      });
    });
    group.gross_weight += Number(row.gross_weight) || 0;
    group.net_weight += Number(row.net_weight) || 0;
    group.cbm += Number(row.cbm) || 0;
  });
  return [...groups.values()].map(({ cartons, ...group }) => {
    const batches = [...cartons.values()];
    group.total_carton_qty = batches.reduce((sum, batch) => sum + (Number(batch.quantity) || 0), 0);
    group.products = batches.flatMap(batch => batch.products.map((product, index) => ({
      ...product, cartonSpan: index === 0 ? batch.products.length : 0,
      carton_quantity: batch.quantity,
      ...Object.fromEntries(['gross_weight', 'net_weight', 'cbm'].map(field => [
        `carton_${field}`, batch[field] ?? batch.products.reduce((sum, item) => sum + Number(item[field] || 0), 0),
      ])),
    })));
    return group;
  });
}

export function addContainerCartonSheet(workbook, reports) {
  const sheet = workbook.addWorksheet('Carton Details');
  sheet.columns = ['Container', 'Type', 'Qty', 'Carton Qty', 'Product', 'Prod Qty', 'Prod Gross (kg)', 'Prod Net (kg)', 'Carton Gross (kg)', 'Carton Net (kg)', 'Carton CBM', 'Gross Wt (kg)', 'Net Wt (kg)', 'Total CBM', 'Marko', 'Warehouse', 'Customer'].map(header => ({ header, width: ['Warehouse', 'Customer', 'Product', 'Marko'].includes(header) ? 30 : 20 }));
  const merges = [];
  reports.forEach(({ container, selected }) => groupSelectedRecords(selected).forEach(item => {
    const products = item.products.length ? item.products : [{}];
    products.forEach((product, index) => {
      const row = sheet.addRow([
        index === 0 ? container.name || container.internal_reference : null,
        index === 0 ? item.packaging_type : null,
        index === 0 ? item.packaging_quantity : null,
        product.cartonSpan ? product.carton_quantity : null,
        product.name || '', product.quantity, product.gross_weight, product.net_weight,
        ...['gross_weight', 'net_weight', 'cbm'].map(field => product.cartonSpan ? product[`carton_${field}`] : null),
        index === 0 ? item.gross_weight : null, index === 0 ? item.net_weight : null, index === 0 ? item.cbm : null,
        index === 0 ? item.marko : null,
        index === 0 ? item.warehouse_code || item.warehouse_name : null, index === 0 ? item.customer_name : null,
      ]);
      if (index === 0 && products.length > 1) [1, 2, 3, 12, 13, 14, 15, 16, 17].forEach(column => merges.push([row.number, column, row.number + products.length - 1, column]));
      if (product.cartonSpan > 1) [4, 9, 10, 11].forEach(column => merges.push([row.number, column, row.number + product.cartonSpan - 1, column]));
    });
  }));
  const numericColumns = new Set([3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14]);
  styleRecordSheet(sheet, { numericColumns });
  merges.forEach(range => sheet.mergeCells(...range));
  const products = reports.flatMap(report => groupSelectedRecords(report.selected).flatMap(record => record.products));
  appendReportSummary(sheet, { labelColumns: 2, productColumn: 5, productCount: new Set(products.map(product => product.product_id || product.name)).size, numericColumns });
  return sheet;
}

